import {ElMessage} from 'element-plus';
import {store_clear_all, store_get} from "../utils/storage"
import axios from "axios"
// 导入nprogress 包对应的js和css
import NProgress from "nprogress"
import 'nprogress/nprogress.css';
import router from "@/router";
import {max_width} from "../common/js/config.default";

//console.log(max_width);
//console.log(window.innerWidth,"==============");

//  axios.create 创建一个axios实例  我们给这个实例编写配置 ， 后续所有通过实例发送的请求，都受当前配置约束
const $http = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 60000,
});

let loadingInstance = null;

// 添加请求拦截器
$http.interceptors.request.use(function (config) {
    NProgress.start();

    //element ui Loading方法
    //loadingInstance = ElLoading.service({
    //  customClass: window.innerWidth < max_width ? 'mLoading' : '',
    //  text: '加载中...',
    //  background: 'rgba(0, 0, 0, 0.7)',
    //})
    // 在发送请求之前做些什么
    const token = store_get('token');
    if (token) {
        config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
$http.interceptors.response.use(function (response) {
    NProgress.done();
    // 请求结束，关闭 loading 动画
    if (loadingInstance) {
        //loadingInstance.close();
    }
    let {config} = response;
    // 对响应数据做点什么
    const data = response.data;
    // console.log(`请求地址:${config.baseURL}${config.url}, 请求方法:${config.method}, 请求参数:${config.data}, 返回的结果:${JSON.stringify(data.data)}`)
    if (data.code !== 200) {
        if (data.code === 403 || data.code === 401) {
            store_clear_all();
            router.push({path: '/'})
            return ElMessage({
                customClass: window.innerWidth < max_width ? 'messageBox' : '',
                type: 'error',
                message: '登录失效，请重新登录',
            })
            //return ElMessage.error('网络错误 ，请退出重新登录');
        }
        return ElMessage({
            customClass: window.innerWidth < max_width ? 'messageBox' : '',
            type: 'error',
            message: data.msg,
        })
        //return ElMessage.error(data.msg);
    }
    return data;
}, function (error) {
    let {message} = error;
    if (message === "Network Error") {
        message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
        message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
        message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    ElMessage({
        customClass: window.innerWidth < max_width ? 'messageBox' : '',
        message: message,
        type: "error",
        duration: 5 * 1000,
    });

    // 对响应错误做点什么
    return Promise.reject(error);
});

export default $http
